import { useState, useEffect } from 'react';
import styles from './Navbar.module.css';
import Button from '../ui/Button';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navLinks = [
    { label: 'The Model', href: '#model' },
    { label: 'Thesis', href: '#thesis' },
    { label: 'Partners', href: '#partners' },
    { label: 'For Founders', href: '#founders' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'Founder', href: '#founder' }
  ];

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
        <div className={styles.container}>
          <a href="#hero" className={styles.logo}>
            <img src="/infundra-logo.svg" alt="infundra" className={styles.logoImg} />
          </a>
          <ul className={styles.navLinks}>
            {navLinks.map(link => (
              <li key={link.href}>
                <a href={link.href} className={styles.navLink}>{link.label}</a>
              </li>
            ))}
          </ul>
          <div className={styles.navActions}>
            <Button to="#inquiries" variant="nav">Contact</Button>
            <button
              className={styles.menuBtn}
              onClick={toggleMenu}
              aria-expanded={menuOpen}
              aria-controls="mobileMenu"
              aria-label="Toggle menu"
            >
              <span className={styles.menuIcon}></span>
              <span className={styles.menuIcon}></span>
              <span className={styles.menuIcon}></span>
            </button>
          </div>
        </div>
      </nav>

      <div
        id="mobileMenu"
        className={`${styles.mobileMenu} ${menuOpen ? styles.open : ''}`}
      >
        {navLinks.map(link => (
          <a
            key={link.href}
            href={link.href}
            className={styles.mobileLink}
            onClick={closeMenu}
          >
            {link.label}
          </a>
        ))}
        <Button to="#inquiries" variant="primary">Contact</Button>
      </div>
    </>
  );
}
